module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-08.c4a1f2b6.svg";